(() => {
  if (customElements.get('soera-expanded-recommendations')) return;
  class ExpandedRecommendations extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.grid = this.querySelector('[data-recommendation-grid]');
      this.more = this.querySelector('[data-recommendation-more]');
      this.count = this.querySelector('[data-recommendation-count]');
      if (!this.grid || !this.more || !this.count) return;
      this.initialized = true;
      this.cards = Array.from(this.grid.children);
      this.media = window.matchMedia('(max-width: 767px)');
      this.expanded = false;
      this.shown = this.initialCount();
      this.onResize = () => {
        if (!this.expanded) this.shown = this.initialCount();
        this.render();
      };
      this.onMore = () => {
        const firstNew = this.shown;
        this.expanded = true;
        this.shown = Math.min(this.cards.length, this.shown + this.batchSize());
        this.render();
        const card = this.cards[firstNew];
        const link = card?.querySelector('.product-link[href]:not([tabindex="-1"]):not([aria-hidden="true"])') || card?.querySelector('a[href]:not([tabindex="-1"]):not([aria-hidden="true"]), button:not([disabled])');
        if (link) link.focus({ preventScroll: true });
      };
      this.more.addEventListener('click', this.onMore);
      this.media.addEventListener('change', this.onResize);
      this.render();
      this.setAttribute('data-enhanced', '');
    }
    disconnectedCallback() {
      if (!this.initialized) return;
      this.more.removeEventListener('click', this.onMore);
      this.media.removeEventListener('change', this.onResize);
      this.initialized = false;
    }
    batchSize() {
      return Number(this.media.matches ? this.dataset.mobileCount : this.dataset.desktopCount) || (this.media.matches ? 8 : 12);
    }
    initialCount() {
      return Math.min(this.cards.length, this.batchSize());
    }
    render() {
      this.cards.forEach((card, index) => {
        card.hidden = index >= this.shown;
        if (!card.hidden) {
          card.querySelectorAll('[data-manual-srcset], [data-manual-src]').forEach(image => {
            if (image.dataset.manualSrcset) {
              image.setAttribute('srcset', image.dataset.manualSrcset);
              delete image.dataset.manualSrcset;
            }
            if (image.dataset.manualSrc) {
              image.setAttribute('src', image.dataset.manualSrc);
              delete image.dataset.manualSrc;
            }
          });
        }
      });
      this.more.hidden = this.shown >= this.cards.length;
      this.count.textContent = this.dataset.countLabel.replaceAll('[count]', this.shown).replaceAll('[total]', this.cards.length);
    }
  }
  customElements.define('soera-expanded-recommendations', ExpandedRecommendations);
})();

// Speed (12 Oct 2026): the related-products grid is no longer rendered with the product page.
// Fetch it from the product recommendations endpoint once the shopper scrolls near it.
(() => {
  const load = placeholder => {
    if (placeholder.dataset.soeraLazyState) return;
    placeholder.dataset.soeraLazyState = 'loading';
    const url = new URL(placeholder.dataset.soeraLazyRelated, window.location.origin);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    fetch(url, { credentials: 'same-origin' })
      .then(response => (response.ok ? response.text() : Promise.reject(new Error(String(response.status)))))
      .then(html => {
        const template = document.createElement('template');
        template.innerHTML = html;
        const sectionId = placeholder.dataset.sectionId;
        const fresh = template.content.querySelector(`.related-products[data-section-id="${sectionId}"]`)
          || template.content.querySelector('.related-products');
        if (!fresh || !placeholder.isConnected) return;
        fresh.querySelectorAll('script').forEach(script => script.remove());
        placeholder.replaceWith(fresh);
        document.dispatchEvent(new CustomEvent('soera:related-products-loaded', { detail: { sectionId } }));
      })
      .catch(() => { placeholder.dataset.soeraLazyState = 'failed'; });
  };
  const MARGIN = 2000;
  const init = () => {
    document.querySelectorAll('[data-soera-lazy-related]').forEach(placeholder => {
      if (!('IntersectionObserver' in window)) { load(placeholder); return; }
      // The placeholder is hidden (no box), so watch its section wrapper.
      const target = placeholder.closest('.shopify-section') || placeholder.parentElement;
      let lastCheck = 0;
      const stop = () => {
        observer.disconnect();
        window.removeEventListener('scroll', onScroll);
      };
      const start = () => { stop(); load(placeholder); };
      const observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) start();
      }, { rootMargin: `${MARGIN}px 0px` });
      // A jump past the section (anchor, back-to-top, End key) never crosses the observer's margin.
      const onScroll = () => {
        const now = Date.now();
        if (now - lastCheck < 150) return;
        lastCheck = now;
        if (target.getBoundingClientRect().top < (window.innerHeight || 800) + MARGIN) start();
      };
      observer.observe(target);
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
